const SOURCE_ERROR = {
  MIDDLEWARE: "M",
  DEVICE: "D",
  BUSINESS_LOCALLY: "B",
  STREAM: "S",
  AUTHENTICATION: "A",
  PARTNER: "P",
  DRM: "R",
  GENERAL: "G"
};
const PLATFORMS_ERROR = {
  ANDROIDTV: "2",
  APPLETV: "4",
  FIRETV: "5",
  ROKU: "6",
  WEB: "7",
  CHROMECAST: "8",
  TIZEN: "9",
  WEBOS: "10",
  HISENSE: "11",
  ZEASN: "12"
};
const LOCATIONS_ERROR = {
  LOGIN: "10",
  SPLASH_SCREEN: "11",
  PDP: "12",
  SETTINGS: "13",
  EPG: "14",
  SEARCH: "15",
  PLAYER_BEFORE_VIDEO_START: "16",
  PLAYER_PLAYBACK: "17",
  CASTING: "18",
  HOME_PAGE: "19",
  LIVE_PAGE: "20",
  CATALOG_PAGE: "21",
  SPORTS_PAGE: "22",
  KIDS_PAGE: "23",
  LANDER: "24",
  MINI_EPG: "25",
  PROFILE_CREATE: "26",
  PROFILE_EDIT: "27",
  PROFILE_DELETE: "28",
  PIN: "29",
  TV_ACTIVATION: "30",
  ZAPPING: "31",
  SEE_MORE_LANDER: "32",
  BACKGROUND_SERVICE: "33",
  MY_LIST: "34",
  IAP_CREATE: "35",
  IAP_DELETE: "36",
  IAP_PURCHASE_FLOW: "37",
  CASTING_CONNECT: "38",
  CASTING_AIRPLAY: "39",
  CASTING_CONNECTING: "40"
};
const TYPEMIDDLEWARE_ERROR = {
  BLACKOUT: "01",
  NOT_IN_REGION: "05",
  REGION_BLOCK: "06",
  AUTHORIZER_CONCURRENT_USER_PLAYBACK_LIMIT: "07",
  AUTHORIZER_CONCURRENT_CHANNEL_PLAYBACK_LIMIT: "08",
  AUTHORIZER_CONCURRENT_DEVICE_LIMIT: "09",
  AUTHORIZER_NOT_VALID_LOGIN_TOKEN: "10",
  AUTHORIZER_NOT_VALID_CUSTOMER_TOKEN: "11",
  AUTHORIZER_NOT_VALID_ASSET_TOKEN: "12",
  AUTHORIZER_EXPIRED_REFRESH_TOKEN: "13",
  AUTHORIZER_OTHERS: "14",
  NOT_IN_PACKAGE_OTT: "18",
  NOT_IN_PACKAGE: "19",
  NOT_IN_PACKAGE_B2B2C: "20",
  REQUEST_TIMED_OUT: "24",
  OTHER_HTTP_ERRORS: "98",
  UNEXPECTED: "99"
};
const TYPEDEVICE_ERROR = {
  LOST_INTERNET_CONNECTION: "04",
  PLAYER_EXCEPTION: "97",
  UNEXPECTED: "99"
};
const TYPEBUSINESSLOCALLY_ERROR = {
  BLACKOUT: "01",
  USER_INACTIVE: "22",
  NOT_ENOUGH_DATA_TO_PLAY_THE_CONTENT: "23",
  UNEXPECTED: "99"
};
const TYPESTREAM_ERROR = {
  REQUEST_TIMED_OUT: "24",
  PLAYER_EXCEPTION: "97",
  OTHER_HTTP_ERRORS: "98",
  UNEXPECTED: "99"
};
const TYPEAUTHENTICATION_ERROR = {
  SESSION_EXPIRED: "15",
  LOGIN_REFRESH_TOKEN_FAILED: "16",
  DEVICE_LIMIT_REACHED: "21",
  REQUEST_TIMED_OUT: "24",
  LOGOUT: "25",
  OTHER_HTTP_ERRORS: "98",
  UNEXPECTED: "99"
};
const TYPEPARTNER_ERROR = {
  REQUEST_TIMED_OUT: "24",
  OTHER_HTTP_ERRORS: "98",
  UNEXPECTED: "99"
};
const TYPEDRM_ERROR = {
  REGION_BLOCK: "06",
  DRM_FAILED: "17",
  REQUEST_TIMED_OUT: "24",
  OTHER_HTTP_ERRORS: "98",
  UNEXPECTED: "99"
};
const TYPE_VERIFICATION = (typeError, sourceError) => {
  if (sourceError === SOURCE_ERROR.MIDDLEWARE) {
    return TYPEMIDDLEWARE_ERROR[typeError];
  }
  if (sourceError === SOURCE_ERROR.DEVICE) {
    return TYPEDEVICE_ERROR[typeError];
  }
  if (sourceError === SOURCE_ERROR.BUSINESS_LOCALLY) {
    return TYPEBUSINESSLOCALLY_ERROR[typeError];
  }
  if (sourceError === SOURCE_ERROR.STREAM) {
    return TYPESTREAM_ERROR[typeError];
  }
  if (sourceError === SOURCE_ERROR.AUTHENTICATION) {
    return TYPEAUTHENTICATION_ERROR[typeError];
  }
  if (sourceError === SOURCE_ERROR.PARTNER) {
    return TYPEPARTNER_ERROR[typeError];
  }
  if (sourceError === SOURCE_ERROR.DRM) {
    return TYPEDRM_ERROR[typeError];
  }
  if (sourceError === SOURCE_ERROR.GENERAL) {
    return "99";
  }
  return "";
};

export { LOCATIONS_ERROR, PLATFORMS_ERROR, SOURCE_ERROR, TYPEAUTHENTICATION_ERROR, TYPEBUSINESSLOCALLY_ERROR, TYPEDEVICE_ERROR, TYPEDRM_ERROR, TYPEMIDDLEWARE_ERROR, TYPEPARTNER_ERROR, TYPESTREAM_ERROR, TYPE_VERIFICATION };
//# sourceMappingURL=Error.js.map
